import { forwardRef } from 'react'

import { useUnit } from 'effector-react'

import { SearchBar } from '@/components/layout/sidebar/search-bar.tsx'
import { Separator } from '@/components/ui/separator.tsx'
import { $account } from '@/models/account.ts'
import { CreatorSelector } from '@/modules/creators/ui/CreatorSelect'
import { classNames } from '@/utils/helpers'
import { useTheme } from '@/utils/useTheme.tsx'

import { useSidebarSections } from './use-sidebar-sections'

interface SidebarProps {
  collapsed: boolean
  onCollapse: (collapsed: boolean) => void
}

export const Sidebar = forwardRef<HTMLElement, SidebarProps>(
  ({ collapsed, onCollapse }: SidebarProps, ref) => {
    const account = useUnit($account)
    const { blackFridayBannerOpen } = useTheme()
    const sections = useSidebarSections({ onCollapse })

    return (
      <aside
        ref={ref}
        id="sidebar"
        className={classNames(
          `fixed ${
            blackFridayBannerOpen
              ? 'top-[136px] h-[calc(100vh-136px)]'
              : 'top-[72px] h-[calc(100vh-72px)]'
          } z-[49] w-[300px] overflow-y-auto border-r bg-card p-6 transition lg:translate-x-0`,
          collapsed && '-translate-x-full',
        )}
      >
        <nav className="flex flex-col">
          <SearchBar
            account={account}
            collapseSidebar={onCollapse}
          />
          <Separator className="mt-6 " />
          <div className="sticky -top-6 left-0 z-10 bg-card py-6">
            <CreatorSelector />
          </div>
          <div className="flex flex-1 flex-col pb-8">{sections}</div>
        </nav>
      </aside>
    )
  },
)

Sidebar.displayName = 'Sidebar'
